module.exports = __webpack_public_path__ + "img/news-slider2-en.8b86ab80.jpg";